import { Fragment } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";

import style from "./style.module.scss";
import type { BreadcrumbProps } from "../../types";

function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav className={classnames(style.breadcrumb, className)}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <Fragment key={index}>
            {item.link && !isLast ? (
              <Link to={item.link} className={style.link}>
                {item.label}
              </Link>
            ) : (
              <span className={style.current}>{item.label}</span>
            )}
            {!isLast && <span className={style.separator}>/</span>}
          </Fragment>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
